import React from 'react';

/**
 * Loading skeleton for Lander1Page
 * Matches the layout structure for instant visual feedback while JS loads
 */
const Lander1Skeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg relative">
      {/* Background overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0D10] via-[#0B0D10]/95 to-[#0B0D10] opacity-50 pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,255,255,0.02)_0%,transparent_70%)] pointer-events-none" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Upload Section */}
          <div className="space-y-8">
            {/* Headline Skeleton */}
            <div className="mb-8 space-y-4">
              <div className="h-12 bg-white/10 rounded-lg w-3/4 animate-pulse" />
              <div className="h-12 bg-white/10 rounded-lg w-2/3 animate-pulse" />
            </div>

            {/* Upload Box Skeleton */}
            <div className="border-2 border-dashed border-white/30 rounded-xl p-12 bg-white/5">
              <div className="flex flex-col items-center space-y-4">
                <div className="w-16 h-16 bg-white/10 rounded-full animate-pulse" />
                <div className="h-6 bg-white/10 rounded w-48 animate-pulse" />
                <div className="h-4 bg-white/10 rounded w-64 animate-pulse" />
              </div>
            </div>
          </div>

          {/* Right Column - Example Grid Skeleton */}
          <div className="grid grid-cols-2 gap-4 sm:gap-6">
            {/* Example Lane 1 Skeleton */}
            <div className="flex flex-col items-center">
              {/* Before Image Skeleton */}
              <div className="w-36 h-36 rounded-2xl bg-white/10 animate-pulse mb-4" />
              
              {/* Arrow Skeleton */}
              <div className="w-6 h-6 bg-white/10 rounded-full animate-pulse my-3" />
              
              {/* After Video Skeleton */}
              <div className="w-full h-80 rounded-2xl bg-white/10 animate-pulse" />
            </div>

            {/* Example Lane 2 Skeleton */}
            <div className="flex flex-col items-center">
              {/* Before Image Skeleton */}
              <div className="w-36 h-36 rounded-2xl bg-white/10 animate-pulse mb-4" />
              
              {/* Arrow Skeleton */}
              <div className="w-6 h-6 bg-white/10 rounded-full animate-pulse my-3" />
              
              {/* After Video Skeleton */}
              <div className="w-full h-80 rounded-2xl bg-white/10 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lander1Skeleton;

